<template>
	<div class="TeakManagement">
		<el-form ref="form" label-width="150px">
			<el-row style='margin-top: 20px;'>
				<el-col :span='6'>

					<el-form-item label="订单类型">
						<el-radio-group v-model="radioresource">
							<el-radio label="试用"></el-radio>
							<el-radio label="正式"></el-radio>
							<el-radio label="全部"></el-radio>
						</el-radio-group>
					</el-form-item>


				</el-col>
				<el-col :span='8'>
					<el-form-item label="订单开始时间">
						<el-date-picker v-model="timvalue" type="daterange" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
				</el-col>
        <el-col :span="5">
          <el-form-item label="订单权限" style=" position: relative">
            <el-select clearable v-model="order_attribute" >
              <el-option label="全部" value=""></el-option>
              <el-option label="PC" value="1"></el-option>
              <el-option label="APP" value="2"></el-option>
              <el-option label="BIMPPT" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
				<el-col :span='3' :offset="2">
					<el-button type="primary" @click='seetabke'>查询</el-button>
				</el-col>
			</el-row>
		</el-form>
		<el-row>
			<el-col>
				<el-table :data="tableData" border style="width: 90%;margin: 0 auto;" max-height="750px">

					<el-table-column prop="organization_name" label="机构名称" align='center'>
					</el-table-column>
					<el-table-column prop="start_time" label="订单开始时间" align='center'  min-width="90px">
					</el-table-column>
					<el-table-column prop="end_time" label="订单结束时间" align='center' min-width="90px">
					</el-table-column>
					<el-table-column prop="order_type" label="订单类型" align='center'>
					</el-table-column>
          <el-table-column prop="order_attribute_name" label="订单权限" align='center' >
					</el-table-column>
					<el-table-column prop="course" label="课程" align='center' min-width="400px">
					</el-table-column>
					<el-table-column prop="create_time" label="	创建时间" align='center' min-width="90px">
					</el-table-column>
				</el-table>

				<el-pagination background layout="prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size='pagesize'
				 :total='allpage' style='margin-left: calc(40%);margin-top: 20px;'>
				</el-pagination>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {
		trainorder_list
	} from "../assets/js/network/network.js";
	export default {
		components: {},
		data() {
			return {
        order_attribute:"",
				radioresource: '',
				timvalue: null,
				tableData: [],
				//分页显示条数
				pagesize: null,
				//所以资源条数
				allpage: null,
				//分页显示当前页面
				current_page: 1,
				page:1
			};
		},
		methods: {
			handleCurrentChange(val){
				this.page=val;
				this.seetabke();
			},
			seetabke(){

				// console.log(this.timvalue)
				let order_type;
				let start_time;
				let end_time;
				if(this.radioresource=='正式'){
					order_type=1;
				}else if(this.radioresource=='试用'){
					order_type=0;
				}else if(this.radioresource=='全部'){
					order_type=''
				}else{
					order_type=''
				}

				if(this.timvalue!=null){
					start_time=this.timvalue[0].getTime()/1000;
					end_time=this.timvalue[1].getTime()/1000;

				}else{
					start_time='';
					end_time='';
				}


				let data={
					order_type,
					start_time,
					end_time,
          order_attribute:this.order_attribute
				}
				// console.log(3333333)
        this.page = 1
				trainorder_list(data,this.page).then(res=>{
					for(let i=0; i<res.ret.data.length; i++){
            let e = res.ret.data[i].end_time
            res.ret.data[i].order_attribute_name = '-'
						res.ret.data[i].start_time=this.GlobalJs._UtilityTime.retun_formatDate11(res.ret.data[i].start_time)
						res.ret.data[i].end_time=this.GlobalJs._UtilityTime.retun_formatDate11(res.ret.data[i].end_time)
            if(e>1893427200){
              res.ret.data[i].end_time = '永久'
            }
						res.ret.data[i].create_time=this.GlobalJs._UtilityTime.retun_formatDate11(res.ret.data[i].create_time)
						res.ret.data[i].order_type=res.ret.data[i].order_type==0?'试用':'正式'
            if(res.ret.data[i].order_attribute == 1){
              res.ret.data[i].order_attribute_name = 'pc'
            }else if(res.ret.data[i].order_attribute == 2){
              res.ret.data[i].order_attribute_name = 'app'
            }else if(res.ret.data[i].order_attribute == 3){
              res.ret.data[i].order_attribute_name = 'bimppt'
            }
					}
					this.tableData=res.ret.data;
					this.pagesize = res.ret.per_page;
					this.allpage = res.ret.total;
					this.current_page = res.ret.current_page;
				})
			}
		},
		mounted() {
			let data={}
			trainorder_list(data,this.page).then(res=>{
			  if(res.code == 0){

          for(let i=0; i<res.ret.data.length; i++){
            let e = res.ret.data[i].end_time
            res.ret.data[i].start_time=this.GlobalJs._UtilityTime.retun_formatDate11(res.ret.data[i].start_time)
            res.ret.data[i].end_time=this.GlobalJs._UtilityTime.retun_formatDate11(res.ret.data[i].end_time)
            res.ret.data[i].create_time=this.GlobalJs._UtilityTime.retun_formatDate11(res.ret.data[i].create_time)
            if(e>1893427200){
              res.ret.data[i].end_time = '永久'
            }
            res.ret.data[i].order_type=res.ret.data[i].order_type==0?'试用':'正式'
            if(res.ret.data[i].order_attribute == 1){
              res.ret.data[i].order_attribute_name = 'pc'
            }else if(res.ret.data[i].order_attribute == 2){
              res.ret.data[i].order_attribute_name = 'app'
            }else if(res.ret.data[i].order_attribute == 3){
              res.ret.data[i].order_attribute_name = 'bimppt'
            }
          }
          this.tableData=res.ret.data;
          this.pagesize = res.ret.per_page;
          this.allpage = res.ret.total;
          this.current_page = res.ret.current_page;
        }

			})
		}
	};
</script>
<style scoped>
	@import "../style/common.css";
</style>
